<template>
  <div :class="$style.loadWrapper">
    <SignupContainer
      :isMsp="isMsp"
    />
  </div>
</template>

<script>
/* eslint import/no-cycle: 0 */
import { SignupConsts } from 'client/util/Constants';
import { mapActions, mapState } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import SignupContainer from 'client/signup/AdminSignup/SignupContainer.vue';

const { screenSizes } = SignupConsts;

export default {
  name: 'AdminSignup',

  components: {
    SignupContainer,
  },

  props: {
    isMsp: {
      type: Boolean,
      default: false,
    },
  },

  EventHelper,
  localStorage,

  computed: {
    ...mapState([
      'step',
      'user',
    ]),

    routeQuery() {
      if (this.$route) {
        return this.$route.query;
      }

      return {};
    },
  },
  watch: {
    routeQuery: {
      handler(value) {
        try {
          if (value) {
            const {
              email,
              rs,
              step,
            } = value;

            // if the marketing site passed along the query string rs for referral source,
            // update that referral url in the growth data object
            if (rs) {
              this.updateReferrer(rs);
              this.$options.EventHelper.triggerReferralSourceSignup({ referralSource: rs });
            }

            this.setStep(step);

            if (window.analytics) {
              const segmentAnonymousId = window.analytics.user().anonymousId();

              // Pass the anonymousId in case we want to set it in Admin Portal
              const segmentMap = {
                signupSegmentId: segmentAnonymousId,
              };

              segmentMap.email = this.user.email || email;

              // Update the segment map with the segment anonymousId
              this.updateSegmentMap(segmentMap);
            }
          }
        } catch (e) {
          // catch and move on
          // this query param processing should not stop signup from completing
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.$options.EventHelper.triggerSignupPageViewed();
    this.updateIsMobileScreen(window.screen.width <= screenSizes.maxMobileDeviceWidth);
    this.fetchFeatureFlags();
  },
  mounted() {
    this.checkStep();
    this.updateHasLoaded(true);
    // Call on initial mount
    // This should parse any marketing values and load existing values from localStorage into Vuex
    this.updateQueryStrings(this.routeQuery);
    this.updateReferrer();
  },
  methods: {
    ...mapActions([
      'setStep',
      'updateHasLoaded',
      'updateIsMobileScreen',
      'updateQueryStrings',
      'updateReferrer',
      'updateSegmentMap',
    ]),

    ...mapActions('FeatureFlagsModule', [
      'fetchFeatureFlags',
    ]),

    checkStep() {
      const showFirstStep = this.step > 1;
      if (showFirstStep) {
        this.$router.replace('/signup');
      }
    },
    getExperimentStates() {
      // This is where you call getExperimentVariation and update the store
      // Then use the store state where needed to display the proper variation
    },
  },
};
</script>

<style scoped module>
  .loadWrapper {
    height: 100%;
  }
</style>
